export enum ProductRequestApprovalStatus {
    APPROVED = 'approved',
    REJECTED = 'rejected',
    PENDING = 'pending',
    NOT_REQUIRED = 'not-required'
}